import React from 'react';
import { ReportTemplateProps } from '../types';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import { SPANISH_WEEK } from '../../helpers';
import dayjs from 'dayjs';

const VentasHora = ({
  reportTitle,
  formattedStartDate,
  formattedEndDate,
  reportData,
}: ReportTemplateProps) => (
  <Paper style={{ padding: '1em 1em 3em 1em' }}>
    {/* Shop: {shop}, Inicio: {startDate}, Fin: {endDate} */}
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom={true}>
          {`${reportData.nombre}: ${reportTitle}`}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom={true} align="right">
          <span style={{ fontWeight: 'bold' }}>Intervalo fechas:</span>{' '}
          {formattedStartDate} / {formattedEndDate}
        </Typography>
      </Grid>
    </Grid>
    <Grid container justifyContent="center">
      <TableContainer
        component={({ children }) => <Grid item>{children}</Grid>}
      >
        <Table size="small" id="report-table">
          <TableHead>
            <TableRow>
              <TableCell>HORA</TableCell>
              <TableCell></TableCell>
              <TableCell align="right">Nº Ventas</TableCell>
              <TableCell align="right">Vendido a peso (Kg)</TableCell>
              <TableCell align="right">IMPORTE(€)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData.detalle.map((dia: any, idx1: number) => (
              <>
                <TableRow key={idx1}>
                  <TableCell>{dia.dia}</TableCell>
                  <TableCell>
                    {SPANISH_WEEK[dayjs(dia.dia, 'DD/MM/YYYY').day()]}
                  </TableCell>
                  <TableCell align="right">{dia.ventas}</TableCell>
                  <TableCell align="right">{`${dia.cantidad}`}</TableCell>
                  <TableCell align="right">{dia.importe}</TableCell>
                </TableRow>
                {dia.horas.map((hora: any, idx2: number) => (
                  <>
                    <TableRow key={idx1 + ',' + idx2}>
                      <TableCell align="right">{hora.hora}</TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">{hora.ventas}</TableCell>
                      <TableCell align="right">{`${hora.cantidad}`}</TableCell>
                      <TableCell align="right">{hora.importe}</TableCell>
                    </TableRow>
                  </>
                ))}
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  </Paper>
);

export default React.memo(VentasHora);
